/**
 * Segurar o botão esquerdo e arrastar DENTRO das linhas rola a lista nos dois
 * eixos (SPEC-20261010-1623-arrastar-para-rolar-a-lista-de-itens, pedido do
 * Cristian: "ao clicar segurar o botão esquerdo pressionado poder arrastar e
 * mover o scroll da esquerda para direita ou direita para esquerda"). O mesmo
 * gesto da Planilha do quadro (SPEC-20260914-2307).
 *
 * Só vira rolagem depois de LIMIAR_DE_ARRASTE px: abaixo disso o gesto ainda é
 * um clique, e abrir o item continua valendo. Depois de arrastar, o clique que
 * o navegador dispara ao soltar é comido — senão abriria o item.
 */
export const LIMIAR_DE_ARRASTE = 5

/** Controles com gesto próprio: o arraste não começa neles. */
export const FORA_DO_ARRASTE =
  'button, a, input, textarea, select, label, [role="columnheader"], [draggable="true"], [contenteditable="true"]'

export const CLASSE_PUXANDO = 'wi-rolagem--puxando'

type InicioDoArraste = {
  button: number
  clientX: number
  clientY: number
  target: EventTarget | null
}

export function iniciarArrasteDeRolagem(e: InicioDoArraste, caixa: HTMLElement | null) {
  if (e.button !== 0 || !caixa) return
  const alvo = e.target as HTMLElement | null
  if (!alvo || alvo.closest?.(FORA_DO_ARRASTE)) return
  // nada para rolar: não sequestrar o gesto
  if (caixa.scrollWidth <= caixa.clientWidth && caixa.scrollHeight <= caixa.clientHeight) return

  const x0 = e.clientX
  const y0 = e.clientY
  const esquerda0 = caixa.scrollLeft
  const topo0 = caixa.scrollTop
  let arrastou = false

  const mover = (ev: PointerEvent) => {
    const dx = ev.clientX - x0
    const dy = ev.clientY - y0
    if (!arrastou) {
      if (Math.hypot(dx, dy) < LIMIAR_DE_ARRASTE) return
      arrastou = true
      caixa.classList.add(CLASSE_PUXANDO)
      // some com a seleção de texto que o arraste teria começado
      window.getSelection()?.removeAllRanges()
    }
    ev.preventDefault()
    caixa.scrollLeft = esquerda0 - dx
    caixa.scrollTop = topo0 - dy
  }
  const soltar = () => {
    window.removeEventListener('pointermove', mover)
    window.removeEventListener('pointerup', soltar)
    window.removeEventListener('pointercancel', soltar)
    caixa.classList.remove(CLASSE_PUXANDO)
    if (!arrastou) return
    const comer = (c: Event) => {
      c.stopPropagation()
      c.preventDefault()
    }
    window.addEventListener('click', comer, { capture: true, once: true })
    // se o clique não vier (soltou fora), desarma na volta do frame
    setTimeout(() => window.removeEventListener('click', comer, { capture: true }), 0)
  }
  window.addEventListener('pointermove', mover, { passive: false })
  window.addEventListener('pointerup', soltar)
  window.addEventListener('pointercancel', soltar)
}
